import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';

const DesktopNotifier = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasBeenShown = sessionStorage.getItem('desktopNotifierShown');
    const isMobile = window.innerWidth < 768;

    if (!hasBeenShown && isMobile) {
      const timer = setTimeout(() => {
        setIsVisible(true);
        sessionStorage.setItem('desktopNotifierShown', 'true');
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          // Responsive classes are applied here
          className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[90%] max-w-md z-[9999] sm:w-auto sm:left-auto sm:right-6 sm:translate-x-0"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        >
          <div className="bg-primary/60 backdrop-blur-md border border-white/10 rounded-xl p-4 flex items-center justify-between shadow-2xl">
            <p className="text-text-secondary text-sm pr-4">
              This site looks good on mobile, but is best experienced on a desktop.
            </p>
            <button
              onClick={() => setIsVisible(false)}
              className="text-text-secondary hover:text-text-primary transition-colors flex-shrink-0"
              aria-label="Close notification"
            >
              <FiX size={20} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DesktopNotifier;